// extracted by css-extract-rspack-plugin
var _1 = "Destiny-m_content-DMIbg7Wz";
export { _1 as "content" }
